const SalesDistribution = () => import(/* webpackChunkName: "SalesDistribution" */ '@/views/SalesDistribution')
const SdMapping = () => import(/* webpackChunkName: "SdMapping" */ '@/views/SalesDistribution/sdMapping')
const SdMappingDetail = () => import(/* webpackChunkName: "SdMappingDetail" */ '@/views/SalesDistribution/sdMappingDetail')
const SdVisit = () => import(/* webpackChunkName: "SdVisit" */ '@/views/SalesDistribution/sdVisit')
const SdVisitDetail = () => import(/* webpackChunkName: "SdVisitDetail" */ '@/views/SalesDistribution/sdVisitDetail')
const SalesDistributionSearch = () => import(/* webpackChunkName: "salesDistributionSearch" */ '@/views/Search/salesDistributionSearch')
const salesDistributionRouter = [
  {
    // path: '', 或者 重定向
    path: '/salesDistribution',
    component: SalesDistribution,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Distributor'
    }
  },
  {
    path: '/salesDistribution/sdMapping',
    component: SdMapping,
    meta: {
      title: 'Distributor Mapping'
    }
  },
  {
    path: '/salesDistribution/sdMappingDetail',
    component: SdMappingDetail,
    meta: {
      title: 'Distributor Info'
    }
  },
  {
    path: '/salesDistribution/sdVisit',
    component: SdVisit,
    meta: {
      title: 'Distributor Visit'
    }
  },
  {
    path: '/salesDistribution/sdVisitDetail',
    component: SdVisitDetail,
    meta: {
      title: 'Distributor Visit Detail'
    }
  },
  {
    path: '/salesDistribution/search',
    component: SalesDistributionSearch,
    meta: {
      title: 'Distributor Search'
    }
  }
]

export default salesDistributionRouter
